import { BUSINESS_NATURE, CUSTOMER_BUSINESS_NATURES } from "../../../common/enums/businessNatures";
import type { ProfileSectionTags } from "../common/ActionReportProfileSection/ActionReportProfileSection";

const DEFAULT_BUSINESS_NATURES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const getBusinessNatures = (aff: string, disableCustomerMembers: boolean): string => {
  let businessNatures = [...DEFAULT_BUSINESS_NATURES];

  if (disableCustomerMembers) {
    businessNatures = businessNatures.filter((b) => ![3, 4].includes(b));
  }

  if (aff === "430") {
    businessNatures = businessNatures.filter((b) => b !== 8);
  }

  return businessNatures.join(",");
};

export const isCustomerBusinessNature = (businessNature: string | undefined): boolean =>
  CUSTOMER_BUSINESS_NATURES.has(Number(businessNature));

export const getBusinessNatureTag = (businessNature: string | undefined): ProfileSectionTags["businessNatureTag"] => {
  switch (Number(businessNature)) {
    case BUSINESS_NATURE.ABO:
      return "abo";
    case BUSINESS_NATURE.MEMBER:
      return "member";
    case BUSINESS_NATURE.CUSTOMER:
      return "customer";
    case BUSINESS_NATURE.GUEST_CUSTOMER:
      return "guestCustomer";
    default:
      return undefined;
  }
};
